export function getPlaceOrderOriginMobileAvailable(state: WtrState) {
  return state?.checkout?.placeOrderOriginMobileAvailable;
}
